import { render } from "./PrintInvoiceMoneyDetailsDesign4.vue?vue&type=template&id=010d9e3e"
import script from "./PrintInvoiceMoneyDetailsDesign4.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceMoneyDetailsDesign4.vue?vue&type=script&lang=js"

import "./PrintInvoiceMoneyDetailsDesign4.vue?vue&type=style&index=0&id=010d9e3e&scoop=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__